import React from "react";


/******** Packages ********/
import { v4 as uuidv4 } from 'uuid';



/******** Style and Assets ********/
import "../../styles/BlockedAccounts.scss";
import userIcon from "../../assets/useIcon2.svg";
// import { UserPlaceholderIcon } from "../../assets/svg";




// ----------------------------------------------------------------------------------------------------------------



export const BlockedAccountsSection = () => {
  
  
  const dummyData = [
    {
      name: "Kamran Sohail",
      number: "0312-12345678",
    },
    {
      name: "Sana Rehman",
      number: "0312-12345678",
    },
    {
      name: "Asim Khan",
      number: "0312-12345678",
    },
    {
      name: "Ahmed Kamran",
      number: "0312-12345678",
    },
    {
      name: "Humaira Imran",
      number: "0312-12345678",
    },
  ];



  return (
    <div className="profile-container">
      {dummyData.map((item, index) => (
        <div
          key={uuidv4()}
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: 20,
            width: '100%',
          }}
        >
          <img
            src={userIcon}
            alt="user-icon"
            style={{
              width: 52,
              height: 52,
              borderRadius:'45px',
            }}
          />
          {/* <div style={{ width: "52px", height: "52px" }}>
            <UserPlaceholderIcon />
          </div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              textAlign: "initial",
              marginTop: 8,
              marginLeft: 4,
            }}
          >
            <p className="name-blocked secondary-text">{item.name}</p>
            <p className="number-blocked">{item.number}</p>
          </div>
        </div>
      ))}
      {/* <div className="dotted-button">Create Folder +</div> */}
    </div>
  );
};